import { createReducer } from '../reducerUtil'
import {
  SHOW_TURNTABLE,
  SET_TURNTABLE_SIZE,
  SET_RESULT_SELECTED,
  SET_CHOICES,
  SET_TYPE_ACTIVE,
  SET_TYPE_COUNT,
  SET_CATEGORY,
  SET_LEVEL,
  SET_HISTORY,
  SET_MODE,
  CHANGE_KEY_TEXT,
  SET_TITLE_OBJ,
  INSTANT_INIT,
  RESET_INITIAL_STATE,
  REPLACE_STATE,
  SET_MYSTERY_WHEEL_ON,
  SET_MYSTERY_RESULT_ON,
  UPDATE_MYSTERY_SETTINGS,
  SET_SCORES,
  SET_AUTO_ADD_COUNT,
} from './constants'
import { allQuestions } from '../../component/ReactTDQ/data'
import cuid from 'cuid'

const initialState = {
  resultSelected: '',
  resultPieColor: null,
  history: [],
  choices: [],
  // [0, 1]
  //   .flatMap(type => {
  //     const levels = [1, 2, 3]
  //     const perLevel = Math.floor(16 / levels.length)
  //     const remainder = 16 % levels.length

  //     const selected = []

  //     levels.forEach((level, index) => {
  //       const levelQuestions = allQuestions.filter(
  //         q => q.type === type && q.category === 0 && q.level === level,
  //       )

  //       const shuffled = [...levelQuestions].sort(() => Math.random() - 0.5)
  //       let take = perLevel

  //       if (index < remainder) take++

  //       selected.push(...shuffled.slice(0, take))
  //     })

  //     return selected
  //   })
  //   .sort(() => Math.random() - 0.5)
  //   .map(q => ({ ...q, filtered: false })),
  // [0, 1]
  //   .flatMap(type =>
  //     allQuestions
  //       .filter(q => q.type === type && q.category === 0)
  //       .sort(() => Math.random() - 0.5)
  //       .slice(0, 16),
  //   )
  //   .sort(() => Math.random() - 0.5)
  //   .map(q => ({ ...q, filtered: false })),  // filter by category 0 and count of each type 16
  typeActive: ['Truth', 'Dare'], // Truth: 0, Dare: 1
  typeCount: { Truth: 16, Dare: 16 },
  category: 0, // 0: Friends
  level: 0,
  title: {
    active: false,
    text: '',
    description: '',
    popup: '',
  },
  turnTable: null,
  turnTableSize: 300,
  inputKeyText: cuid(),
  mode: 0,
  mysteryWheelOn: false,
  mysteryResultOn: false,
  scores: [],
  autoAddCount: false,
}

export const setResultSelected = (state, payload) => {
  return {
    ...state,
    resultSelected: payload.result,
    resultIndex: payload.resultIndex,
    resultPieColor: payload.resultPieColor,
  }
}

export const setChoices = (state, payload) => {
  return {
    ...state,
    choices: payload.choices,
    turnTable: payload.nullTurntable ? null : state.turnTable,
  }
}

export const setTypeActive = (state, payload) => {
  return {
    ...state,
    typeActive: payload.typeActive,
  }
}

export const setTypeCount = (state, payload) => {
  return {
    ...state,
    typeCount: payload.typeCount,
  }
}

export const setCategory = (state, payload) => {
  return {
    ...state,
    category: payload.category,
  }
}

export const setLevel = (state, payload) => {
  return {
    ...state,
    level: payload.level,
  }
}

export const showTurntable = (state, payload) => {
  return {
    ...state,
    turnTable: payload.turntable,
  }
}

export const setTurntableSize = (state, payload) => {
  return {
    ...state,
    turnTable: state.turnTableSize === payload.size ? state.turnTable : null,
    turnTableSize: payload.size,
  }
}

export const setHistory = (state, payload) => {
  return {
    ...state,
    history: payload.history,
  }
}

export const setMode = (state, payload) => {
  return {
    ...state,
    mode: payload.mode,
  }
}

export const changeKeyText = (state, payload) => {
  return {
    ...state,
    inputKeyText: cuid(),
  }
}

export const setTitleObj = (state, payload) => {
  return {
    ...state,
    title: {
      ...state.title,
      ...payload.obj,
    },
  }
}

export const instantInit = (state, payload) => {
  if (!payload.previousState) {
    return {
      ...state,
    }
  } else {
    return {
      ...payload.previousState,
    }
  }
}

export const resetInitialState = (state, payload) => {
  const { turnTableSize, ...rest } = initialState
  return {
    ...state,
    ...rest,
  }
}

export const replaceState = (state, payload) => {
  return {
    ...state,
    ...payload.data,
  }
}

export const setMysteryWheelOn = (state, payload) => {
  return {
    ...state,
    mysteryWheelOn: payload.status,
    turnTable: null,
  }
}

export const setMysteryResultOn = (state, payload) => {
  return {
    ...state,
    mysteryResultOn: payload.status,
  }
}

export const updateMysterySettings = (state, payload) => {
  return {
    ...state,
    mysteryWheelOn: payload.mysteryWheelOn,
    mysteryResultOn: payload.mysteryResultOn,
  }
}

export const setScores = (state, payload) => {
  return {
    ...state,
    scores: payload.scores,
  }
}

export const setAutoAddCount = (state, payload) => {
  return {
    ...state,
    autoAddCount: payload.status,
  }
}

export default createReducer(initialState, {
  [SHOW_TURNTABLE]: showTurntable,
  [SET_RESULT_SELECTED]: setResultSelected,
  [SET_CHOICES]: setChoices,
  [SET_TYPE_ACTIVE]: setTypeActive,
  [SET_TYPE_COUNT]: setTypeCount,
  [SET_CATEGORY]: setCategory,
  [SET_LEVEL]: setLevel,
  [SET_TURNTABLE_SIZE]: setTurntableSize,
  [SET_HISTORY]: setHistory,
  [SET_MODE]: setMode,
  [CHANGE_KEY_TEXT]: changeKeyText,
  [SET_TITLE_OBJ]: setTitleObj,
  [INSTANT_INIT]: instantInit,
  [RESET_INITIAL_STATE]: resetInitialState,
  [REPLACE_STATE]: replaceState,
  [SET_MYSTERY_WHEEL_ON]: setMysteryWheelOn,
  [SET_MYSTERY_RESULT_ON]: setMysteryResultOn,
  [UPDATE_MYSTERY_SETTINGS]: updateMysterySettings,
  [SET_SCORES]: setScores,
  [SET_AUTO_ADD_COUNT]: setAutoAddCount,
})
